import React from 'react'
import { Link } from 'react-router-dom'

export const TermsOfServicePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-6 px-4 sm:py-12 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white shadow-sm rounded-lg p-6 sm:p-8">
          <div className="mb-8">
            <Link
              to="/signup"
              className="text-blue-600 hover:text-blue-700 text-sm font-medium"
            >
              ← 회원가입으로 돌아가기
            </Link>
          </div>
          
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-8">서비스 이용약관</h1>
          
          <div className="prose max-w-none">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">제1조 (목적)</h2>
            <p className="text-gray-700 mb-6">
              이 약관은 POD24(이하 "회사")가 제공하는 스마트 제조 지원 서비스(이하 "서비스")의 이용과 관련하여 
              회사와 회원 간의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">제2조 (정의)</h2>
            <p className="text-gray-700 mb-6">
              1. "서비스"란 회사가 제공하는 스마트 제조 데이터 수집, 분석, 시각화 및 알람 서비스를 의미합니다.<br/>
              2. "회원"이란 이 약관에 따라 회사와 이용계약을 체결하고 서비스를 이용하는 자를 의미합니다.<br/>
              3. "계정"이란 서비스 이용을 위해 회원이 등록한 고유한 식별자를 의미합니다.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">제3조 (약관의 효력과 변경)</h2>
            <p className="text-gray-700 mb-6">
              1. 이 약관은 서비스 화면에 게시하여 공시합니다.<br/>
              2. 회사는 필요한 경우 이 약관을 변경할 수 있으며, 변경된 약관은 7일 전에 공지합니다.<br/>
              3. 회원이 변경된 약관에 동의하지 않을 경우 서비스 이용을 중단하고 탈퇴할 수 있습니다.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">제4조 (회원가입)</h2>
            <p className="text-gray-700 mb-6">
              1. 회원가입은 이용신청자가 이 약관에 동의한 후 회사가 정한 양식에 따라 회원정보를 기입하여 신청합니다.<br/>
              2. 회사는 다음 각 호에 해당하는 신청에 대하여는 승낙하지 않을 수 있습니다.<br/>
              - 실명이 아니거나 타인의 명의를 이용한 경우<br/>
              - 허위 정보를 기재한 경우<br/>
              - 기타 회사가 정한 이용신청 요건을 충족하지 못한 경우
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">제5조 (서비스의 제공)</h2>
            <p className="text-gray-700 mb-6">
              1. 회사는 다음과 같은 서비스를 제공합니다:<br/>
              - 제조 데이터 자동 수집 및 저장<br/>
              - 실시간 데이터 모니터링 및 분석<br/>
              - 시각화 대시보드 제공<br/>
              - 이상 상황 알람 서비스<br/>
              - 기타 회사가 추가로 개발하는 부가서비스
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">제6조 (회원의 의무)</h2>
            <p className="text-gray-700 mb-6">
              1. 회원은 서비스 이용 시 다음 행위를 해서는 안 됩니다:<br/>
              - 타인의 정보 도용<br/>
              - 서비스의 정상적인 운영에 방해가 되는 행위<br/>
              - 회사의 지적재산권을 침해하는 행위<br/>
              - 기타 관계법령에 위배되는 행위
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">제7조 (서비스 이용제한)</h2>
            <p className="text-gray-700 mb-6">
              회사는 회원이 이 약관의 의무를 위반하거나 서비스의 정상적인 운영을 방해한 경우, 
              경고, 일시정지, 영구이용정지 등으로 서비스 이용을 단계적으로 제한할 수 있습니다.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mb-4">제8조 (면책조항)</h2>
            <p className="text-gray-700 mb-6">
              1. 회사는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 책임이 면제됩니다.<br/>
              2. 회사는 회원의 귀책사유로 인한 서비스 이용의 장애에 대하여는 책임지지 않습니다.<br/>
              3. 회사는 서비스에 표출된 정보, 자료, 사실의 신뢰도, 정확성 등의 내용에 관하여는 책임지지 않습니다.
            </p>

            <p className="text-sm text-gray-500 mt-8">
              시행일자: 2025년 1월 1일
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}